var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5934_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1104 23.797C14.4716 24.4706 15.1823 24.9286 16 24.9286C16.8177 24.9286 17.5284 24.4706 17.8897 23.797",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0891 8.69135C13.1264 7.65413 14.5331 7.07141 16 7.07141C17.4669 7.07141 18.8736 7.65413 19.9109 8.69135C20.9481 9.72858 21.5309 11.1354 21.5309 12.6022C21.5309 13.4653 21.6733 14.2763 21.8876 15.1059C21.9476 15.2936 22.0137 15.4708 22.0849 15.638C22.4163 16.4177 23.3289 16.6837 24.0099 17.1878C25.0263 17.9403 24.8297 19.5503 23.9843 20.1754C23.9843 20.1754 22.6193 21.3571 16 21.3571C9.38068 21.3571 8.01571 20.1754 8.01571 20.1754C7.1703 19.5503 6.9738 17.9403 7.99019 17.1878C8.67112 16.6837 9.58369 16.4177 9.91522 15.6381C10.2457 14.8609 10.4692 13.8668 10.4692 12.6022C10.4692 11.1354 11.0519 9.72858 12.0891 8.69135Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5934_3071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3c25bdb46c334cfe24ee2428a7715832.svg";
export { ForwardRef as ReactComponent };